import { ModuleGraphOutput } from 'module/model/page/graph/module-graph.output';
import { ModuleGraph } from 'module/page/graph/module-graph';

export abstract class ModuleGraphConverterPort {
	public abstract asModuleGraph(output: ModuleGraphOutput): ModuleGraph;
}
